import React, { useEffect } from 'react';
import { useNews } from '../context/NewsContext';
import {
    Box,
    Typography,
    Container,
    alpha
} from '@mui/material';
import NewsJournalCard from '../components/news/NewsJournalCard';

const AllNewsPage = () => {
    const { publishedNews } = useNews();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Box sx={{ width: '100%', minHeight: '100vh', bgcolor: 'common.white' }}>
            {/* HERO SECTION - DEEP BLACK CINEMATIC */}
            <Box sx={{
                bgcolor: '#050505',
                color: 'common.white',
                pt: 20,
                pb: 12,
                position: 'relative',
                overflow: 'hidden'
            }}>
                {/* Background Ambient Mesh */}
                <Box sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: `
                        radial-gradient(circle at 10% 20%, ${alpha('#CC0000', 0.08)} 0%, transparent 40%),
                        radial-gradient(circle at 90% 80%, ${alpha('#1a1a1a', 1)} 0%, transparent 60%)
                    `,
                    pointerEvents: 'none'
                }} />

                <Container maxWidth={false} sx={{ maxWidth: '1200px', position: 'relative', zIndex: 2 }}>
                    <Typography
                        variant="overline"
                        sx={{
                            color: 'grey.500',
                            letterSpacing: '0.2em',
                            mb: 2,
                            display: 'block',
                            fontWeight: 600
                        }}
                    >
                        R5 // PANORAMA
                    </Typography>
                    <Typography
                        variant="h1"
                        sx={{
                            fontSize: { xs: '3.5rem', md: '5rem' },
                            fontWeight: 800,
                            lineHeight: 1.05,
                            letterSpacing: '-0.02em',
                            color: 'common.white',
                            mb: 3
                        }}
                    >
                        Notícias & <br />
                        <Box component="span" sx={{ color: 'grey.500' }}>Atualizações.</Box>
                    </Typography>
                    <Typography
                        variant="h6"
                        sx={{
                            color: 'grey.400',
                            maxWidth: '600px',
                            fontWeight: 400,
                            lineHeight: 1.6,
                            fontSize: '1.25rem'
                        }}
                    >
                        Acompanhe as últimas novidades, lançamentos e atualizações oficiais sobre a R5 Inteligência Digital.
                    </Typography>
                </Container>
            </Box>

            {/* GRID SECTION */}
            <Container maxWidth={false} sx={{ maxWidth: '1200px', py: 10 }}>
                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', // Stricter min-width for editorial look
                    gap: '40px', // Proper breathing room
                    width: '100%',
                }}>
                    {publishedNews && publishedNews.length > 0 ? (
                        publishedNews.map((item) => (
                            <NewsJournalCard key={item.id} item={item} />
                        ))
                    ) : (
                        <Box sx={{ gridColumn: '1 / -1', py: 12, textAlign: 'center', bgcolor: 'grey.50', borderRadius: '24px' }}>
                            <Typography variant="h5" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                                Nenhuma notícia encontrada.
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Container>
        </Box>
    );
};

export default AllNewsPage;
